var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hidden)?_c('div',{staticClass:"generic-modal-container",class:{
    opened: !_vm.hidden,
    'bg-clip-padding bg-gray-50 backdrop-filter bg-opacity-50 px-2': !_vm.hidden,
    opaque: _vm.isOpaque
},on:{"click":_vm.bgClicked}},[_c('div',{staticClass:"generic-fs-modal bg-white p-0 md:p-2 -mt-2 border-gray-200 border rounded-lg max-w-full w-full md:w-4/5"},[_c('div',{staticClass:"overflow-y-scroll h-[83vh] md:h-[65vh]"},[(_vm.filesystemId)?_c('fs',{ref:'fs',attrs:{"show-options":false,"filesystem-id":_vm.filesystemId,"path":_vm.filesystemPath}}):_vm._e()],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }